import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BoxDiv } from './box';
import DataTimePlate from './datetime-plate';
import JieqiPlate from './jieqi-plate';


const Notice = styled.h1`
  display: block;
  font-size: 30px;
  color: #12a5ec;
  font-weight: normal;
  line-height: 103px;
  margin: 0;
  margin-left: 20px;
`;

class ReportHeader extends Component {
  render() {
    const [date, time, jieqi] = this.props.displayTime.split(' ');
    return (
      <BoxDiv style={{ height: '103px', borderBottom: '1px solid #f9f9f9', position: 'relative', }}>
        <Notice>此系统由中医药大学中医专家审核</Notice>
        <div style={{ position: 'absolute', top: '14px', right: '104px' }}>
          <DataTimePlate date={date} time={time} />
        </div>
        <div style={{ position: 'absolute', top: '21px', right: '21px' }}>
          <JieqiPlate jieqi={jieqi} />
        </div>
      </BoxDiv>
    );
  }
}

ReportHeader.propTypes = {
  displayTime: PropTypes.string.isRequired,
};
ReportHeader.defaultProps = {};

export default ReportHeader;



// WEBPACK FOOTER //
// ./src/components/report-header.jsx